import * as React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

export default function DropDownAssetPhotos(props) {
    const { SetCoverPhoto, RemoveImage, MoveNext, MovePrevious, ImageId, Conditions } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (e) => {
        if (e.target.innerText.includes("Set as cover image")) {
            SetCoverPhoto(ImageId)
        } else if (e.target.innerText.includes("Delete")) {
            RemoveImage(ImageId)
        } else if (e.target.innerText.includes("Move forward")) {
            MoveNext(ImageId)
        } else if (e.target.innerText.includes("Move backward")) {
            MovePrevious(ImageId)
        }
        setAnchorEl(null);
    };
    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="Options">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        bgcolor="red"
                    >
                        <MoreHorizIcon sx={{ borderRadius: '8px', color: 'white', bgcolor: "#06487E" }} />
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                className='DDAPhotos-menu'
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleClose} disabled={Conditions === true ? true : false}>
                    Move forward
                </MenuItem>
                <MenuItem onClick={handleClose} disabled={Conditions === true ? true : false}>
                    Move backward
                </MenuItem>
                <MenuItem onClick={handleClose} disabled={Conditions === true ? true : false}>
                    Set as cover image
                </MenuItem>
                <MenuItem onClick={handleClose}>
                    Delete
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}
